export const environment = {
    production: false,
    apiUrl: 'https://test.wikipiedra.asmws.net'
};
